// Shared framer-motion presets (hoisted so props keep stable references)
export const EXPAND = {
  initial: { opacity: 0, height: 0 },
  animate: { opacity: 1, height: "auto" },
  exit: { opacity: 0, height: 0 },
};
